<agr-page-toolbar
  [isEmpty]="(animalGroup$ | async)?.feedAdviceApplications.length === 0"
  [emptyTitle]="'animal-group.feedadvices.no-feedadvices-title' | translate"
  [emptyDescription]="'animal-group.feedadvices.no-feedadvices-description' | translate"
  emptyImage="assets/images/pigs_001.jpg"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="addFeedAdviceApplication()"
  data-test="feedadvice-overview"
>
  <ng-container
    *ngIf="
      (isLoading$ | async) === false &&
      (animalGroup$ | async)?.feedAdviceApplications as feedAdviceApplications
    "
  >
    <mat-nav-list role="list" *ngIf="feedAdviceApplications?.length">
      <a
        mat-list-item
        *ngFor="let feedadvice of feedAdviceApplications"
        role="listitem"
        [attr.data-test]="'feedadvice-overview__item_' + feedadvice.id"
        (click)="editFeedAdviceApplication(feedadvice.id)"
      >
        <mat-icon
          matListItemAvatar
          class="list-avatar"
          style="color: white; background: rgba(0, 0, 0, 0.18)"
        >
          view_list
        </mat-icon>
        <div matListItemTitle>
          {{ getFeedadviceName(feedadvice) | async }} ({{
            feedadvice.feedAdviceApplicabilityPercentage
          }}%)
        </div>
        <div matListItemLine class="text--gray">
          {{ feedadvice?.startDate | date }} - {{ feedadvice?.endDate | date }}
        </div>
        <div matListItemMeta>
          <button
            mat-icon-button
            (click)="delete($event, feedadvice)"
            data-test="feedadvice-overview__delete-item"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </a>
      <mat-divider *ngIf="feedAdviceApplications.length > 0"></mat-divider>
    </mat-nav-list>
  </ng-container>
</agr-page-toolbar>
